import { useContext, useEffect } from "react"

import { SerializedError } from "@reduxjs/toolkit"
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query"

import { PopUpContext } from "../PopUpContext"
import { RecipeContext } from "../RecipeContext"
import { ErrorResponse, ErrorResponseDjango } from "~/types/global-types"
import { getErrorMessage } from "~/utils/errors"

interface PropTypes {
  isSuccess: boolean
  isLoading: boolean
  isError: boolean
  error: SerializedError | FetchBaseQueryError | undefined
  onSuccess?: () => void
  onError?: () => void
}

const exceptions = new Map([
  ["description", "Les emojis ne sont pas autorisés"],
])

export default function useAutosavePopUp({
  isSuccess,
  isLoading,
  isError,
  error,
  onSuccess,
  onError,
}: PropTypes) {
  const popUp = useContext(PopUpContext)
  const recipeContext = useContext(RecipeContext)

  useEffect(() => {
    if (!isLoading && isSuccess) {
      popUp?.setContent({
        type: "saved",
        message:
          "Votre formulaire de recette est enregistrée automatiquement !",
      })
      recipeContext?.refetchRecipe()
      onSuccess?.()
    }
    if (!isLoading && isError) {
      const errorMessage = getErrorMessage(
        (
          error as unknown as {
            data?: ErrorResponse | ErrorResponseDjango
          }
        )?.data
      )
      const errorMessageWithException =
        exceptions.get(errorMessage ?? "") ??
        errorMessage ??
        "Une erreur est survenue"

      popUp?.setContent({
        type: "error",
        message: errorMessageWithException,
      })
      onError?.()
    }
  }, [isSuccess, isLoading, isError, error])
}
